import React, { useEffect } from 'react';
import Alert from '../Alert';
import { Notification as NotificationType } from '../../../slices/notifications/types';

interface FlashNotificationProps {
    notification: NotificationType;
    onDismiss: (id: string) => void;
}

// Icon mapping based on TenantRentalConfig pattern
const getNotificationIcon = (type: string): string => {
    switch (type) {
        case 'success':
            return 'ri-check-line';
        case 'error':
            return 'ri-error-warning-line';
        case 'warning':
            return 'ri-alert-line';
        case 'info':
            return 'ri-information-line';
        default:
            return 'ri-information-line';
    }
};

// Color mapping → Alert colour
const getAlertColor = (type: string): string => {
    switch (type) {
        case 'success':
            return 'success';
        case 'error':
            return 'danger';
        case 'warning':
            return 'warning';
        case 'info':
            return 'info';
        default:
            return 'info';
    }
};

const FlashNotification: React.FC<FlashNotificationProps> = ({
    notification,
    onDismiss,
}) => {
    useEffect(() => {
        if (notification.duration && notification.duration > 0) {
            const timer = setTimeout(() => {
                onDismiss(notification.id);
            }, notification.duration);

            return () => clearTimeout(timer);
        }
    }, [notification.id, notification.duration, onDismiss]);

    return (
        <Alert
            color={getAlertColor(notification.type)}
            className="tw-mb-2 tw-flex tw-items-start tw-gap-2 tw-shadow-sm"
        >
            <i className={`${getNotificationIcon(notification.type)} tw-mt-0.5`}></i>
            <div className="tw-flex-1 tw-min-w-0">
                {notification.title && <strong>{notification.title}: </strong>}
                {notification.message}
            </div>
            {notification.dismissible && (
                <button
                    type="button"
                    className="tw-ml-2 tw-text-lg tw-leading-none tw-opacity-60 tw-transition hover:tw-opacity-100"
                    onClick={() => onDismiss(notification.id)}
                    aria-label="Close"
                >
                    &times;
                </button>
            )}
        </Alert>
    );
};

export default FlashNotification;
